import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from '@emotion/styled';
export var StyledModalMessage = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tword-wrap: break-word;\n\tmargin-top: 5px;\n"])));